/*

export interface TableFeature<TData extends RowData = any> {
  createCell?: (
    cell: Cell<TData, unknown>,
    column: Column<TData>,
    row: Row<TData>,
    table: Table<TData>
  ) => void
  createColumn?: (column: Column<TData, unknown>, table: Table<TData>) => void
  createHeader?: (header: Header<TData, unknown>, table: Table<TData>) => void
  createRow?: (row: Row<TData>, table: Table<TData>) => void
  createTable?: (table: Table<TData>) => void
  getDefaultColumnDef?: () => Partial<ColumnDef<TData, unknown>>
  getDefaultOptions?: (
    table: Table<TData>
  ) => Partial<TableOptionsResolved<TData>>
  getInitialState?: (initialState?: InitialTableState) => Partial<TableState>
}

*/

export const AlignFeature = {
    getDefaultOptions() {
        return {
            enableAlignAttributes: true,
        };
    },

    createColumn(column, table) {
        if (!table.options.enableAlignAttributes) return;

        const { align, headerAlign = align, footerAlign = headerAlign } = column.columnDef;

        if (align) column.align = align;
        if (headerAlign) column.headerAlign = headerAlign;
        if (footerAlign) column.footerAlign = footerAlign;
    },
};
